import script from "./QrScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./QrScanner.vue?vue&type=script&setup=true&lang=js"

import "./QrScanner.vue?vue&type=style&index=0&id=b03c34dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b03c34dc"]])

export default __exports__